module.exports = __webpack_public_path__ + "static/media/22-10.ccddf1da.mp3";